<template>
<div id="top1">
    <div class="cc-header">
        <!--<dv-decoration-7 :color="['#f00', '#f00']" style="width: 5rem;height: 0.5rem;"><div style="margin: 0 0.1rem;"> 温度检测监控 </div></dv-decoration-7>-->
        温度检测监控
    </div>
    <div class="top-left-cmp">
        <div class="dc-left">
            <div class="main-value">
                <dv-decoration-9 style="width: 3.5rem;height: 3.5rem;">
                    <span style="color: #4CAF50;">{{count}}</span>
                </dv-decoration-9>
            </div>
            <div class="dc-text">
                高温报警次数
                <dv-decoration-3 style="width:100px;height:20px;" />
            </div>
        </div>
        <div class="dc-right">
            <div class="dc-text">
                当日检测次数
                <dv-decoration-3 style="width:100px;height:20px;" />
            </div>
            <div class="main-value">
                <dv-decoration-9 style="width: 2rem;height: 2rem;">
                    <span style="color: #F44336;">{{high}}</span>
                </dv-decoration-9>
            </div>
        </div>
    </div>
</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
export default {
    data() {
        return {
            count: '0',
            high: '0'
        };
    },
    mounted() {
        this.initData();
        // 定时器刷新，5秒
        let _this = this;
        setInterval(() => {
            _this.initData(); // 修改数据date
        }, 5000);
    },
    methods: {
        initData() {
            let _this = this;
            this.$http.get("/dataView/temp/getTempStatistic?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var result = res.data.result;
                    _this.count = result.count.toString();
                    _this.high = result.high.toString();
                }
            });
        }
    }
};
</script>

<style lang="scss">
#top1 {
    height: 6.8rem;
    transform: rotateY(180deg);

    .cc-header {
        height: 0.75rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .top-left-cmp {
        display: flex;
        height: 5rem;
        margin-left: 0.5rem;

        .dc-left,
        .dc-right {
            width: 50%;
            padding-left: 0.5rem;
        }

        .dc-text {
            display: flex;
            flex-direction: column;
            font-size: 0.25rem;
            box-sizing: border-box;
            justify-content: center;
        }

        .dc-left .main-value {
            height: 65%;
        }

        .dc-left .dc-text {
            height: 35%;
            align-items: flex-end;
        }

        .dc-right .dc-text {
            height: 65%;
        }

        .dc-right .main-value {
            height: 35%;
        }

        .main-value {
            span {
                font-weight: bold;
                font-size: 0.8rem;
            }
        }
    }
}
</style>
